import { HateoasCacheItem } from './hateoas-cache-item';

export class HateoasCache {
  static instance : HateoasCache = new HateoasCache();

  private _cache : Map<string, HateoasCacheItem>;

  constructor() {
    this._cache = new Map<string, HateoasCacheItem>();
    if(!HateoasCache.instance){
      HateoasCache.instance = this;
    }
    return HateoasCache.instance;
  }

  public get(href: string) : any {
    return this._cache.get(href);
  }

  public set(href: string, data: any) : void {
    this._cache.set(href, new HateoasCacheItem(href, data));
  }

  public has(href: string) : boolean {
    return this._cache.has(href);
  }

  public delete(href: string) : void {
    this._cache.delete(href);
  }

  public clear() : void {
    this._cache.clear();
  }

}
